export default function Footer() {
  const cols = [
    {
      title: "吃瓜栏目",
      links: ["今日新瓜", "最近瓜点", "热瓜有哪些", "最新瓜单"],
    },
    {
      title: "围观阵地",
      links: ["评论区风向", "热梗雷达", "吃瓜避雷", "投稿爆料"],
    },
    {
      title: "关于吃瓜m",
      links: ["关于我们", "吃瓜公约", "投稿指南", "联系我们"],
    },
  ];

  return (
    <footer className="border-t border-background-200/70 bg-background-100/70">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-[1.4fr_repeat(3,0.7fr)]">
          <div>
            <a href="#top" className="flex items-center gap-2" aria-label="吃瓜m 回顶">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-black text-background-50">
                瓜
              </span>
              <span className="font-heading text-xl font-black tracking-tight text-foreground-950">
                吃瓜<span className="text-primary-600">m</span>
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              一站式聚合今日新瓜、最近瓜点与最新瓜单的吃瓜社区。站内内容为演示用虚构文本，理性吃瓜，不传播未经证实的传闻。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {["今日吃瓜现场", "热梗雷达", "理性吃瓜"].map((t) => (
                <span
                  key={t}
                  className="rounded-full bg-background-200/60 px-3 py-1 text-xs font-medium text-foreground-600"
                >
                  {t}
                </span>
              ))}
            </div>
          </div>

          {cols.map((col) => (
            <nav key={col.title} aria-label={col.title}>
              <p className="mb-4 text-sm font-bold text-foreground-950">{col.title}</p>
              <ul className="space-y-2.5">
                {col.links.map((link) => (
                  <li key={link}>
                    <a
                      href="#top"
                      className="inline-flex items-center gap-1.5 text-sm text-foreground-600 transition hover:text-primary-600"
                    >
                      <i className="ri-arrow-right-s-line text-primary-400" />
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>
      </div>

      <div className="border-t border-background-200/70">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-4 py-5 text-center text-xs text-foreground-500 sm:flex-row md:px-6">
          <p>© {new Date().getFullYear()} 吃瓜m · 一个靠瓜续命的文字聚合站</p>
          <p className="inline-flex items-center gap-1.5">
            <i className="ri-verified-badge-fill text-primary-500" />
            理性吃瓜 · 瓜有真有假，先验货再上桌
          </p>
        </div>
      </div>
    </footer>
  );
}